import React from 'react'

import {
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Checkbox
} from '@mui/material'

import { eTypeAlert } from '../../../../enums/eTypeAlert'

import { utcToLocal } from '../../../../utils/dateHelper'

import { PositionAlertDetail } from '../../../../interfaces/PositionAlerts/PositionAlerts'

import DoneIcon from '@mui/icons-material/Done'

import TuneIcon from '@mui/icons-material/TuneOutlined'
import { useFlows } from '../../../../hooks/useFlows'
import { ModalReturnType } from '../../../../hooks/useModal'

import { useExpirationIndicator } from '../../../../hooks/useExpirationStatus'

interface PositionAlertTableBodyProps {
  details: PositionAlertDetail[] | undefined
  checkedElements: number[]
  onCheckElement: (positionAlertDetailId: number) => void
  onElementDone: (positionAlertDetailId: number) => void
  onAdjustElement: (id: number, row: PositionAlertDetail) => void
  confirmModalState: ModalReturnType<{
    message: string
    onConfirm: () => void
  }>
}

export const PositionAlertTableBody: React.FC<PositionAlertTableBodyProps> = ({
  details = [],
  checkedElements,
  onCheckElement,
  onElementDone,
  onAdjustElement,
  confirmModalState
}) => {
  const {
    flowsState: { flows }
  } = useFlows()

  return (
    <TableBody>
      {details.map((rowData) => (
        <TableRow key={rowData.positionAlertDetailId}>
          {details.some(
            (el) =>
              el.action === 'REVISIÓN' || el.typeAlertId === eTypeAlert.External
          ) && (
            <TableCell padding='normal'>
              {(rowData.action === 'REVISIÓN' ||
                rowData.typeAlertId === eTypeAlert.External) && (
                <Checkbox
                  checked={checkedElements.includes(
                    rowData.positionAlertDetailId
                  )}
                  onChange={() => onCheckElement(rowData.positionAlertDetailId)}
                />
              )}
            </TableCell>
          )}
          <TableCell>{rowData.typeAlert}</TableCell>
          <TableCell>{utcToLocal(rowData.alertDate, 'dd/MM/yyyy')}</TableCell>
          <TableCell>
            {flows?.find((flow) => flow.flowId === rowData.flowId)
              ?.description || 'Sin Origen'}
          </TableCell>
          <TableCell>{rowData.username}</TableCell>
          <TableCell>{rowData.action}</TableCell>
          <TableCell>{rowData.sku}</TableCell>
          <TableCell>{rowData.skuName}</TableCell>
          {details.some((el) => el.comments) && (
            <TableCell>{rowData.comments || '-'}</TableCell>
          )}
          <TableCell
            style={{
              backgroundColor: useExpirationIndicator(
                rowData.expirationStatus || ''
              )
            }}
          >
            {(rowData.batchId &&
              (rowData.batchNumber ||
                utcToLocal(rowData.expirationDate!, 'dd-MM-yyyy'))) ||
              'N/A'}
          </TableCell>
          <TableCell>{rowData.quantity}</TableCell>
          {(rowData.action === 'REVISIÓN' ||
            rowData.typeAlertId === eTypeAlert.External) && (
            <TableCell>
              <IconButton
                onClick={() =>
                  confirmModalState.openModal('sm', {
                    message:
                      '¿Está seguro que desea liberar alerta seleccionada?',
                    onConfirm: () =>
                      onElementDone(rowData.positionAlertDetailId)
                  })
                }
              >
                <DoneIcon />
              </IconButton>
            </TableCell>
          )}
          <TableCell>
            {rowData.action === 'AJUSTE' &&
              rowData.typeAlertId !== eTypeAlert.External && (
                <Tooltip title='Resolver Incidencia' aria-label='edit'>
                  <IconButton
                    aria-label='seeBinacle'
                    onClick={() =>
                      onAdjustElement(rowData.positionAlertDetailId, rowData)
                    }
                    style={{ verticalAlign: 'bottom' }}
                    disabled={rowData.typeAlertId !== eTypeAlert.Incidence}
                  >
                    <TuneIcon />
                  </IconButton>
                </Tooltip>
              )}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
